import { CompaniesEffects } from './companies/companies.effects';
import { SupplierEffects } from './suppliers/supplier.effects';
import { HsnEffects } from './hsn-code/hsn.effects';
import { ItemEffects } from './item/item.effects';
import { CategoryEffects } from './categories/category.effects';
import { BatchEffects } from './batch/batch.effects';
import { DoctorEffects } from './doctor/doctor.effects';
import { CompanyGroupEffects } from './company-group/company-group.effects';
import { PurchaseEffects } from './purchase/purchase.effects';
import { SalesEffects } from './sales/sales.effects';
import { StorageRackEffects } from './storage-rack/storage-rack.effects';
import { ScheduleEffects } from './schedule/schedule.effects';
import { PurchaseReturnEffects } from './purchase-return/purchase-return.effects';
import { BankEffects } from './bank/bank.effects';
import { RolesEffects } from './roles/roles.effects';
export const AppEffects = [
  CompaniesEffects,
  SupplierEffects,
  HsnEffects,
  ItemEffects,
  CategoryEffects,
  BatchEffects,
  DoctorEffects,
  CompanyGroupEffects,
  PurchaseEffects,
  SalesEffects,
  StorageRackEffects,
  ScheduleEffects,
  PurchaseReturnEffects,
  BankEffects,
  RolesEffects,
];
